import {createSelector} from "reselect";
import {RouteGroup, RouteGroupEntity} from "../../../model/route-group";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";

export type RouteGroupSelectorProps = {
  regionId?: string
};

const getRegionIdParam = createParamSelector<RouteGroupSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const routeGroupSelector = () => createSelector(
  [getUseQueryResultData<RouteGroup>],
  (data) => {
    return data ? transformRouteGroup(data) : undefined;
  }
);

export const routeGroupsSelector = () => createSelector(
  [getUseQueryResultData<RouteGroup[]>, getRegionIdParam],
  (data, regionId) => {
    return selectRouteGroupsAndTransform(
      data ?? [], {
        regionId: regionId
      }
    );
  }
);

export const transformRouteGroup = (value: RouteGroup): RouteGroupEntity => {
  return RouteGroupEntity.from(value)
}

export const selectRouteGroups = (values?: RouteGroup[], selector?: RouteGroupSelectorProps): RouteGroup[] => {
  if (!values) {
    return [];
  }

  return values.filter((e) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (!e.regionId || e.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const selectRouteGroupsAndTransform = (values?: RouteGroup[], selector?: RouteGroupSelectorProps): RouteGroupEntity[] => {
  const selected = selectRouteGroups(values, selector);
  return selected.map(transformRouteGroup);
};
